import { get } from 'svelte/store';

import { getActivityApi, joinActivityApi } from '../api';
import { activityId, isLogin, showRetentionPopup } from '../store/index';
import { getH5CreditCardUrl } from '../utils/jumpTo';
import {
    applyRewardClaimToStore,
    getMatchedRewardActivityId
} from '../utils/rewardClaimStorage';
import { callErrorTrack } from '../utils/track';

export type ActivityConfigData = {
    activityId?: string | number;
    retentionPopup?: boolean | string | number;
};

export type ReceiveRewardData = {
    activityFullDTOList?: Array<{ activityDTO?: { activityId?: string } }>;
};

export const getActivity = () => {
    return new Promise<ActivityConfigData>((resolve, reject) => {
        getActivityApi()
            .then((res) => {
                const { errno, errmsg, traceId } = res;

                if (errno === 0) {
                    resolve((res?.data ?? {}) as ActivityConfigData);
                } else {
                    callErrorTrack('getActivityApi', `${errmsg}_${traceId}`);
                    reject(res);
                }
            })
            .catch((err: Error) => {
                callErrorTrack('getActivityApi', err?.message);
                reject(err || 'getActivityApi fail');
            });
    });
};

/** 从 query/config 拉取 landing 配置写入 store，供跳转/预加载申卡 URL 使用 */
export const initActivityIdFromConfig = async () => {
    try {
        const data = await getActivity();
        const aid = data?.activityId;

        if (aid !== undefined && aid !== null && aid !== '') {
            activityId.set(String(aid));
        }

        const retentionPopup = data?.retentionPopup;

        if (retentionPopup === undefined || retentionPopup === null) {
            showRetentionPopup.set(true);
        } else {
            showRetentionPopup.set(
                retentionPopup === true ||
                    retentionPopup === 'true' ||
                    retentionPopup === 1 ||
                    retentionPopup === '1'
            );
        }

        console.log(
            '[MXCreditCardBALL] credit card url after config:',
            getH5CreditCardUrl()
        );
    } catch {
        console.log('[MXCreditCardBALL] initActivityIdFromConfig error');
    }
};

const readSessionActivityId = (): string | null => {
    if (get(isLogin)) {
        applyRewardClaimToStore();

        return getMatchedRewardActivityId() || get(activityId) || null;
    }

    return get(activityId) || null;
};

/** 从 config 接口拉取 activityId 写入 store（领奖 cookie 仅由领奖成功时写入） */
export const fetchActivityIdFromConfig = async (): Promise<string | null> => {
    try {
        const data = await getActivity();
        const aid = data?.activityId;

        if (aid !== undefined && aid !== null && aid !== '') {
            const aidStr = String(aid);

            activityId.set(aidStr);

            return aidStr;
        }
    } catch {
        console.log('[MXCreditCardBALL] fetchActivityIdFromConfig error');
    }

    return null;
};

/**
 * 预加载前确保 activityId：cookie(uid+ticket) → store → config 接口
 */
export const ensureActivityIdForPreload = async (): Promise<string | null> => {
    const sessionAid = readSessionActivityId();

    if (sessionAid) {
        activityId.set(sessionAid);

        return sessionAid;
    }

    console.log('[MXCreditCardBALL] activityId missing, fetching from config api');

    return fetchActivityIdFromConfig();
};

export const receiveReward = () => {
    return new Promise<ReceiveRewardData>((resolve, reject) => {
        joinActivityApi()
            .then((res) => {
                const { errno, errmsg, traceId } = res;

                if (errno === 0) {
                    resolve((res?.data ?? {}) as ReceiveRewardData);
                } else {
                    callErrorTrack('joinActivityApi', `${errmsg}_${traceId}`);
                    reject(res);
                }
            })
            .catch((err: Error) => {
                callErrorTrack('joinActivityApi', err?.message);
                reject(err || 'joinActivityApi fail');
            });
    });
};
